export class ConditionalDescription {
  value: boolean;
  description: string;
}
